(function ($) {
    'use strict';

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, thisLen) {
            if (thisLen === undefined || thisLen > this.length) {
                thisLen = this.length;
            }

            return this.substring(thisLen - search.length, thisLen) === search;
        };
    }

    $.fn.toggleExpanded = function () {
        var $self = $(this); 

        if ($self.attr('aria-expanded') === 'false') {
            $self.attr('aria-expanded', 'true');
        } else {
            $self.attr('aria-expanded', 'false');
        }
    };

    function expandableSectionMenu() {
        var base = 'submenu-',
            counter = 0,
            curr = document.location.href.split('#')[0];

        $('.section-nav-list > li > ul li').each(function () {
            var $self = $(this),
                $ul = $self.children('ul'),
                id = base + counter.toString(),
                $anchor = $self.children('a:not(.section-nav-toggler)'),
                href = $anchor.attr('href');

            if (curr.endsWith(href) && href !== '') {
                $self.addClass('active');
            }

            if ($ul.length > 0) {

                $self.prepend('<a href="" class="section-nav-toggler" aria-expanded="false" data-target="' + id + '"aria-controls="' + id + '">toggle submenu</a>');
                $ul.attr('id', id);
                counter++;
            }
        });

        $('.section-nav-list .section-nav-toggler').click(function (event) {
            event.preventDefault();
            $(this).parent().toggleClass('open').children('ul').slideToggle(100);
            $(this).toggleExpanded();
        });
    }

    $(document).ready(function () {
        var navPos = $('.navbar.navbar-expand-lg').offset();

        window.mobileCheck();
        window.buildNavigation();
        window.textResizerInit();
        window.addFileReaderDownloadLinks();
        window.CollapsibleCard();
        window.exitLinkNotificaton();

        expandableSectionMenu();

        $('#content').breakLongURLs();

        $('.banner-box').detectBackgroundImageColor();

        $(window).resize(function () {
            window.mobileCheck();

        });

        $(window).scroll(function () {
            window.mobileCheck();
    
            if ($(this).scrollTop() > navPos.top) {
                if (!$('.navbar.navbar-expand-lg').hasClass('fixed')) {
                $('.navbar.navbar-expand-lg').addClass('fixed');
                }
            } else {
                $('.navbar.navbar-expand-lg').removeClass('fixed');
            }

        });
    });

}(jQuery));